import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Slider from 'react-slick'
import tinycolor from 'tinycolor2'
import classnames from 'classnames'
import ButtonPrimary from '../../components/buttons/primary'

class ArtistHotspot extends Component {
  calculateExperience = (start) => {
    if (isNaN(start)) { return false }

    let _currentYear = new Date().getFullYear()

    return _currentYear - start + ' years xp.';
  }

  renderArtists() {
    const sliderSettings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 200,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      autoplay: false,
      mobileFirst: true,
      swipeToSlide: false
    }

    let artistsDivs = _.map(this.props.pages, (artist, key) => {
      if (artist.parent === 5) {
        let _acf = artist.acf
        let fullName = artist.title ? artist.title.rendered : null
        let position = _acf.position ? _acf.position : null
        let experience = this.calculateExperience(_acf.start_date)
        let image = _acf.home_display_image ? _acf.home_display_image.sizes.large : null
        let firstName = fullName.substring(0, fullName.indexOf(' ')) || fullName
        let color = _acf.background_color ? _acf.background_color : null

        if (!image) { return false }

        return (
          <div className={ classnames('artist-hotspot__slide', {'is-light': tinycolor(color).isLight()}) } key={ key }>
            <div className="artist-hotspot__block" style={{ backgroundColor: color }}>
              <div className="artist-hotspot__content">
                <span className="artist-hotspot__name" dangerouslySetInnerHTML={{ __html: firstName.replace(/\S/g, '<span>$&</span>') }}></span>
                <span className="artist-hotspot__position">{ position }</span>
                <span className="artist-hotspot__experience">{ experience }</span>
                <ButtonPrimary className="artist-hotspot__button" to={ 'team/' + artist.slug }>see my art</ButtonPrimary>
              </div>
              <img className="artist-hotspot__image" src={ image } alt={ fullName } />
            </div>
          </div>
        )
      }
    })

    if (artistsDivs.length > 0) {
      if (this.props.slider) {
        return <Slider className="artist-hotspot__slider" { ...sliderSettings }>{ artistsDivs }</Slider>
      } else {
        return <div>{ artistsDivs }</div>
      }
    }
  }

  render() {
    return (
      <div className="artist-hotspot">
        { this.renderArtists() }
      </div>
    )
  }
}

ArtistHotspot.propTypes = {
  pages: PropTypes.array.isRequired
}

export default ArtistHotspot;



// WEBPACK FOOTER //
// ./src/components/artist-hotspot/index.js